'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var hqoTheme = require('./hqo-theme-587e766d.js');
var React = require('react');
var React__default = _interopDefault(React);
require('./svg-icon-501cae97.js');
var confirmed = require('./confirmed-45bc4a9e.js');
var styles$t = require('./styles-4efe67ee.js');

var StepTabs = function (_a) {
    var tabSize = _a.tabSize, tabs = _a.tabs, onTabClick = _a.onTabClick, _b = _a.activeTab, activeTab = _b === void 0 ? 0 : _b, className = _a.className;
    var handleOnTabClick = React.useCallback(function (tabIndex) { return function () {
        if (!onTabClick)
            return;
        onTabClick(tabIndex);
    }; }, [onTabClick]);
    var iconVariants = React.useMemo(function () { return ({
        default: { background: hqoTheme.hqoTheme.colors.greys.adminGreyLight, color: hqoTheme.hqoTheme.colors.greys.adminGreyDark },
        active: { background: hqoTheme.hqoTheme.colorsRgba.primary_1, color: hqoTheme.hqoTheme.colors.primary },
        completed: { background: hqoTheme.hqoTheme.colors.admin.green, color: hqoTheme.hqoTheme.colors.greys.adminGreyLight },
    }); }, []);
    var iconVariant = React.useCallback(function (tab, tabIndex) {
        if (tab.isCompleted)
            return iconVariants.completed;
        if (activeTab === tabIndex)
            return iconVariants.active;
        return iconVariants.default;
    }, [activeTab, iconVariants]);
    return (React__default.createElement(styles$t.StepTabsContainer, { hasGaps: !tabSize, className: className }, tabs.map(function (tab, index) {
        var tabIndex = tab.index || index;
        var _a = iconVariant(tab, tabIndex), background = _a.background, color = _a.color;
        return (React__default.createElement(styles$t.StyledTab, { dataTestId: "tab-" + tabIndex, key: tab.label, variant: activeTab === tabIndex ? 'active' : tab.variant, disabled: tab.disabled || activeTab === tabIndex, tabSize: tabSize, onClick: handleOnTabClick(tabIndex), isCompleted: tab.isCompleted, className: tab.className },
            React__default.createElement(styles$t.HeaderSpan, null,
                React__default.createElement(styles$t.StyledIcon, { background: background, color: color }, tab.isCompleted ? React__default.createElement(confirmed.Confirmed, { variant: "white", size: "xs" }) : tabIndex + 1),
                tab.label)));
    })));
};

exports.StepTabs = StepTabs;
